import { useEffect, useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@letrustech/letrus-ui';
import { Link, useNavigate } from 'react-router-dom';
import { useLogout } from 'APIs/letrusAPI/logout';
import { getUserData } from 'utils/functions/getUserData';
import { useMobile } from 'utils/hooks';
import styles from './DropdownAccount.module.scss';

function DropdownAccount() {
  const [listOpen, setListOpen] = useState(false);

  const { isMobile } = useMobile();
  const navigate = useNavigate();
  const isOnLayers = !!window.sessionStorage.getItem('LayersPlatform');
  const { user } = getUserData();
  const logout = useLogout();

  const dropdownItems = [
    {
      id: 1,
      title: 'Configurações',
      url: '/perfil',
      icon: ['fas', 'cog'] as IconProp,
    },
    {
      id: 2,

      children: !isOnLayers && (
        <Button
          variant="tertiary"
          onClick={() =>
            logout.trigger(null, {
              onSuccess: () => navigate('/login'),
            })
          }
        >
          <FontAwesomeIcon icon="sign-out-alt" />
          Sair
        </Button>
      ),
    },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      const dropdown = document.querySelector(
        '[data-ref-id="DropdownAccount"]'
      );

      if (dropdown && !dropdown.contains(event.target)) {
        setListOpen(false);
      }
    }

    if (listOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [listOpen]);

  function toggleList() {
    setListOpen(!listOpen);
  }

  return (
    <div
      className={styles.dropdownAccount}
      data-testid="dropdown-account"
      data-ref-id="DropdownAccount"
    >
      <Button variant="tertiary" onClick={() => toggleList()}>
        <FontAwesomeIcon icon={isMobile ? 'user-circle' : 'chevron-down'} />
        {isMobile ? '' : 'Minha Conta'}
      </Button>

      {/* TODO: this dropdown component will be changed for a new design */}
      {listOpen && (
        <div className={styles.list}>
          <div className={styles.userData}>
            <h3>{`${user?.first_name} ${user?.last_name}`}</h3>

            <span>{user?.email}</span>
          </div>
          <ul>
            {dropdownItems?.map((item) => (
              <li className={styles.item} key={item.id}>
                {item.children ? (
                  item.children
                ) : (
                  <Link to={item.url!}>
                    <FontAwesomeIcon icon={item.icon!} />
                    {item.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DropdownAccount;
